module.exports = __webpack_public_path__ + "static/media/voluntarios.1e4c2082.jpg";